module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_dn-881ed7524233587ecd9e518f09040fbe.png";